import { api } from '@/services/axios'

export async function deleteCampaign(id: number) {
  const response = await api.delete(`Campanha/Delete/${id}`)
  return response.data
}
